
import {
    SET_VIDEO,
    SET_VIDEO_ERROR,
    SET_VIDEO_LOADING,
    SET_MY_VIDEO
  } from "../actionTypes";
  
  const initialState = {
    video: [],
    myVideo: [],
    videoError: null,
    videoLoading: false
  };
  
  const videoReducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case SET_VIDEO:
        return {
          ...state,
          video: payload,
        };
      case SET_VIDEO_ERROR:
        return {
          ...state,
          videoError: payload,
        };
  
      case SET_VIDEO_LOADING:
        return {
          ...state,
          videoLoading: payload,
        };

        case SET_MY_VIDEO:
        return {
          ...state,
          myVideo: payload,
        };
      default:
        return state;
    }
  };
  
  export default videoReducer;
  